import { useState, useEffect, useRef } from 'react';
import api from '../api';

const GLOBAL_DEFAULTS = {
  ff: 100, stdMargin: 15, spp: 35,
  coef1: 1.45, irp: 0.76, drr: 5, turnover: 120, tax: 6, commission: 20, coefSklad: 1,
  logBase: 0, logExtra: 0, storageBase: 0, storageExtra: 0,
};

const FIXED_COLS = [
  { label: 'Фото',             w: 44  },
  { label: 'Артикул продавца', w: 140 },
  { label: 'Артикул WB',       w: 90  },
  { label: 'Категория',        w: 80  },
];
const FIXED_W = FIXED_COLS.reduce((a,b) => a + b.w, 0);
const FIXED_BG = '#0d1420';

const SCROLL_GROUPS = [
  { label: 'Себес. товара',           color: '#1a1208', cols: [
    { label: 'Себес.',         w: 80 },
    { label: 'ФФ',             w: 60 },
    { label: 'Итог',           w: 80 },
  ]},
  { label: 'Прибыль без РК',          color: '#0a1a14', cols: [
    { label: 'Чистая прибыль', w: 100 },
    { label: 'Рента',          w: 70  },
    { label: 'Маржа',          w: 70  },
    { label: 'Маржа FBS',      w: 80  },
  ]},
  { label: 'Прибыль с РК',            color: '#091610', cols: [
    { label: 'Чистая прибыль', w: 100 },
    { label: 'Рента',          w: 70  },
    { label: 'Маржа',          w: 70  },
    { label: 'Маржа FBS',      w: 80  },
  ]},
  { label: 'Ценообразование',         color: '#0d1526', cols: [
    { label: 'Цена до СПП',    w: 100 },
    { label: 'Цена с СПП',     w: 100 },
  ]},
  { label: 'Стоимость возврата',      color: '#0b1220', cols: [
    { label: 'Стоимость возврата', w: 110 },
  ]},
  { label: 'Логистика WB + % выкупа', color: '#130f1a', cols: [
    { label: 'Процент выкупа', w: 90  },
    { label: 'Логистика база', w: 90  },
    { label: 'Объём (л)',      w: 80  },
    { label: 'ИРП',            w: 50  },
    { label: 'Итог',           w: 70  },
  ]},
  { label: 'Доля логистики',          color: '#0f111a', cols: [
    { label: 'Доля логистики', w: 100 },
  ]},
  { label: 'ДРР факт заказ',          color: '#1a1508', cols: [
    { label: 'ДРР факт заказ', w: 100 },
  ]},
  { label: 'ДРР факт выкуп',          color: '#0a1e16', accent: '#10b981', cols: [
    { label: 'ДРР факт выкуп', w: 100 },
  ]},
  { label: 'ДРР',                     color: '#0f111a', cols: [
    { label: 'Заказ',          w: 70  },
    { label: 'Выкуп',          w: 70  },
  ]},
  { label: 'Хранение (в месяц)',      color: '#0b1220', cols: [
    { label: 'Сумма на 1 ед. (в день)', w: 120 },
    { label: 'Итог',           w: 70  },
  ]},
  { label: 'Комиссия WB',             color: '#1a0d0d', cols: [
    { label: 'Комиссия на 1 ед.', w: 110 },
    { label: 'Итог',           w: 70  },
  ]},
  { label: 'Комиссия WB FBS',          color: '#1a0f0f', cols: [
    { label: 'Комиссия на 1 ед.', w: 110 },
    { label: 'Итог',           w: 70  },
  ]},
  { label: 'Сумма налога',            color: '#160b0b', cols: [
    { label: '% Налога',       w: 70  },
    { label: 'Итог',           w: 70  },
  ]},
];

const SCROLL_COLS = SCROLL_GROUPS.flatMap(g => g.cols.map(c => ({ ...c, groupColor: g.color, groupAccent: g.accent || null })));
const ROW_H = 46;
const HEAD1_H = 30;
const HEAD2_H = 28;
const TOTAL_W = FIXED_W + SCROLL_COLS.reduce((a,b) => a + b.w, 0);
const FIXED_LEFTS = FIXED_COLS.reduce((acc, col, i) => {
  acc.push(i === 0 ? 0 : acc[i-1] + FIXED_COLS[i-1].w);
  return acc;
}, []);

function GlobalParam({ label, value, onChange, suffix = '₽' }) {
  return (
    <div style={{ display:'flex', alignItems:'center', gap:6, background:'#0f111a', border:'1px solid rgba(255,255,255,0.08)', borderRadius:8, padding:'5px 10px' }}>
      {label && <span style={{ fontSize:11, color:'rgba(200,215,235,0.55)', whiteSpace:'nowrap' }}>{label}:</span>}
      <input type="number" value={value} onChange={e => onChange(Number(e.target.value))}
        style={{ width:56, background:'transparent', border:'none', color:'#fff', fontSize:12, fontWeight:600, padding:'2px 0', outline:'none', textAlign:'right' }}/>
      {suffix && <span style={{ fontSize:11, color:'rgba(200,215,235,0.4)' }}>{suffix}</span>}
    </div>
  );
}

export default function UnitEconomics() {
  const [params, setParams] = useState(GLOBAL_DEFAULTS);
  const [paramsLoaded, setParamsLoaded] = useState(false);
  const set = (key) => (val) => {
    setHistory(h => [...h.slice(0, historyIdx + 1), { rowData, articles: [...articles], params }].slice(-50));
    setHistoryIdx(i => Math.min(i + 1, 49));
    setParams(p => {
      const next = { ...p, [key]: val };
      api.post('/monitoring/unit-params', next).catch(()=>{});
      return next;
    });
  };

  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterTag, setFilterTag] = useState('all');
  const [search, setSearch] = useState('');
  const [showHidden, setShowHidden] = useState(false);
  const [importing, setImporting] = useState(false);
  const [importingCost, setImportingCost] = useState(false);
  const [prices, setPrices] = useState({});
  const [costs, setCosts] = useState({});
  const fileRef = useRef(null);
  const costFileRef = useRef(null);
  const commFileRef = useRef(null);
  const [importingComm, setImportingComm] = useState(false);
  const commFbsFileRef = useRef(null);
  const [importingCommFbs, setImportingCommFbs] = useState(false);
  const [rowData, setRowData] = useState({});
  const [draftData, setDraftData] = useState({});
  const [openDrafts, setOpenDrafts] = useState({});
  const [history, setHistory] = useState([]);
  const [historyIdx, setHistoryIdx] = useState(-1);

  const getGlobalDefault = (colLabel, groupColor) => {
    if (colLabel === 'ФФ' && groupColor === '#1a1208') return String(params.ff);
    if (colLabel === '% Налога') return String(params.tax);
    if (colLabel === 'Коэф склада') return String(params.coefSklad);
    return null;
  };

  const setCellVal = (nmId, colLabel, groupColor, val) => {
    const key = String(nmId);
    const cellKey = colLabel + '|' + groupColor;
    const globalDefault = getGlobalDefault(colLabel, groupColor);
    const storeVal = (globalDefault !== null && val === String(globalDefault)) ? null : val;
    if (window._unitSaveTimers) clearTimeout(window._unitSaveTimers[nmId+'|'+cellKey]);
    if (!window._unitSaveTimers) window._unitSaveTimers = {};
    window._unitSaveTimers[nmId+'|'+cellKey] = setTimeout(() => {
      api.post('/monitoring/unit-row-data', { nmId: Number(nmId), cellKey, cellValue: storeVal }).catch(()=>{});
    }, 2000);
    setRowData(prev => {
      const updated = { ...(prev[key] || {}), [cellKey]: storeVal };
      if (colLabel === 'Цена до СПП') {
        delete updated['Цена с СПП|' + groupColor];
        api.post('/monitoring/unit-row-data', { nmId: Number(nmId), cellKey: 'Цена с СПП|' + groupColor, cellValue: null }).catch(()=>{});
      }
      const next = { ...prev, [key]: updated };
      setHistory(h => [...h.slice(0, historyIdx + 1), { rowData: prev, articles }].slice(-50));
      setHistoryIdx(idx => Math.min(idx + 1, 49));
      return next;
    });
  };

  useEffect(() => {
    api.get('/monitoring/unit-articles').then(r => setArticles(r.data)).catch(()=>{}).finally(()=>setLoading(false));
    api.get('/monitoring/prices').then(r => setPrices(r.data)).catch(()=>{});
    api.get('/monitoring/costs').then(r => setCosts(r.data)).catch(()=>{});
    api.get('/monitoring/unit-params').then(r => { if (r.data) setParams(p => ({...p, ...r.data})); }).catch(()=>{}).finally(()=>setParamsLoaded(true));
    api.get('/monitoring/unit-row-data').then(r => setRowData(r.data || {})).catch(()=>{});
    api.get('/monitoring/unit-row-data-draft').then(r => setDraftData(r.data || {})).catch(()=>{});
  }, []);

  const toggleHidden = (nmId) => {
    const id = String(nmId);
    const art = articles.find(a => String(a.nm_id) === id);
    if (!art) return;
    setHistory(h => [...h.slice(0, historyIdx + 1), { rowData, articles: [...articles] }].slice(-50));
    setHistoryIdx(i => Math.min(i + 1, 49));
    if (art.is_hidden) { api.delete('/monitoring/unit-hidden/' + id).catch(()=>{}); }
    else { api.post('/monitoring/unit-hidden/' + id).catch(()=>{}); }
    setArticles(prev => {
      const next = prev.map(a => String(a.nm_id) === id ? {...a, is_hidden: !a.is_hidden} : a);
      if (next.filter(a => a.is_hidden).length === 0) setShowHidden(false);
      return next;
    });
  };

  const handleTag = (nmId) => {
    const id = String(nmId);
    const art = articles.find(a => String(a.nm_id) === id);
    if (!art) return;
    const next = art.tag === '' ? 'top' : art.tag === 'top' ? 'flop' : '';
    api.post('/monitoring/unit-tags/' + id, { tag: next }).catch(()=>{});
    setArticles(prev => prev.map(a => String(a.nm_id) === id ? {...a, tag: next} : a));
  };

  const handleImportVolumes = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImporting(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const r = await api.post('/monitoring/import-volumes', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      alert(`Обновлено ${r.data.updated} артикулов из ${r.data.total}`);
      const res = await api.get('/monitoring/unit-articles');
      setArticles(res.data);
    } catch(e) { alert('Ошибка: ' + (e.response?.data?.error || e.message)); }
    finally { setImporting(false); e.target.value = ''; }
  };

  const handleImportCost = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImportingCost(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const r = await api.post('/monitoring/import-cost', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      alert(`Себестоимость обновлена: ${r.data.updated} артикулов`);
      const res = await api.get('/monitoring/costs');
      setCosts(res.data);
    } catch(e) { alert('Ошибка: ' + (e.response?.data?.error || e.message)); }
    finally { setImportingCost(false); e.target.value = ''; }
  };

  const handleImportCommissionFbs = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImportingCommFbs(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const r = await api.post('/monitoring/import-commission-fbs', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      alert(`Комиссии FBS обновлены: ${r.data.updated} товаров`);
      const res = await api.get('/monitoring/unit-row-data');
      setRowData(res.data || {});
    } catch(e) { alert('Ошибка: ' + (e.response?.data?.error || e.message)); }
    finally { setImportingCommFbs(false); e.target.value = ''; }
  };
  const handleImportCommission = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImportingComm(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const r = await api.post('/monitoring/import-commission', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      alert(`Комиссии обновлены: ${r.data.updated} товаров по ${r.data.subjects} предметам (не найдено предметов: ${r.data.notFound})`);
      const res = await api.get('/monitoring/unit-row-data');
      setRowData(res.data || {});
    } catch(e) { alert('Ошибка: ' + (e.response?.data?.error || e.message)); }
    finally { setImportingComm(false); e.target.value = ''; }
  };

  useEffect(() => {
    const handler = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'z' && !e.shiftKey) {
        e.preventDefault();
        setHistory(h => {
          if (h.length === 0 || historyIdx < 0) return h;
          const snap = h[historyIdx];
          setRowData(snap.rowData);
          if (snap.articles) setArticles(snap.articles);
          setHistoryIdx(idx => idx - 1);
          return h;
        });
      }
      if ((e.ctrlKey || e.metaKey) && e.key === 'z' && e.shiftKey) {
        e.preventDefault();
        setHistory(h => {
          if (historyIdx >= h.length - 1) return h;
          const snap = h[historyIdx + 2];
          if (!snap) return h;
          setRowData(snap.rowData);
          if (snap.articles) setArticles(snap.articles);
          setHistoryIdx(idx => idx + 1);
          return h;
        });
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [historyIdx]);

  const calcLogBase = (vol) => {
    if (!vol || vol <= 0) return null;
    const v = Number(vol);
    if (v > 1) return Math.round((Number(params.logBase) + (v - 1) * Number(params.logExtra)) * 10) / 10;
    if (v <= 0.200) return 23;
    if (v <= 0.400) return 26;
    if (v <= 0.600) return 29;
    if (v <= 0.800) return 30;
    return 32;
  };

  // ─── Универсальная функция эффективных значений ─────────────────────────
  const getEV = (a) => {
    const id = String(a.nm_id);
    const pd = prices[id] || {};
    const manualP = rowData[id]?.['Цена до СПП|#0d1526'];
    const price = manualP != null ? Number(manualP) : (pd.price != null ? Number(pd.price) : 0);
    const actualSpp = pd.spp_pct != null ? Number(pd.spp_pct) : Number(params.spp);
    const manualSpp = rowData[id]?.['Цена с СПП|#0d1526'];
    const priceSpp = manualSpp != null ? Number(manualSpp) :
      (manualP != null ? Math.round(price*(1-actualSpp/100)*100)/100 :
      (pd.price_spp != null ? Number(pd.price_spp) : Math.round(price*(1-actualSpp/100)*100)/100));
    const cost = Number(rowData[id]?.['Себес.|#1a1208'] ?? costs[id] ?? 0);
    const ff = Number(rowData[id]?.['ФФ|#1a1208'] ?? params.ff);
    const itogSeb = cost + ff;
    const vol = rowData[id]?.['Объём (л)|#130f1a'] ?? a.volume;
    const volN = Number(vol);
    const logBase = Number(rowData[id]?.['Логистика база|#130f1a'] ?? calcLogBase(vol) ?? 0);
    const vozvrat = Number(rowData[id]?.['Стоимость возврата|#0b1220'] ?? logBase);
    const buyout = Number(rowData[id]?.['Процент выкупа|#130f1a'] ?? a.buyout_avg ?? a.buyout_w1 ?? 30);
    const il = Number(params.coef1||1);
    const koef = Number(params.coefSklad||1);
    const irp = price > 0 ? Math.round(params.irp*price/100*100)/100 : 0;
    const deliv = logBase*koef*il+irp;
    const itogLog = buyout > 0 ? Math.round(((100-buyout)*(vozvrat+deliv)/buyout+deliv)*100)/100 : 0;
    const baseH = Number(params.storageBase||0);
    const extraH = Number(params.storageExtra||0);
    const sumDayAuto = vol != null && volN > 0 ? (volN>1 ? Math.round((baseH+(volN-1)*extraH)*1000)/1000 : Math.round(baseH*1000)/1000) : 0;
    const sumDay = rowData[id]?.['Сумма на 1 ед. (в день)|#0b1220'] != null ? Number(rowData[id]['Сумма на 1 ед. (в день)|#0b1220']) : sumDayAuto;
    const itogHran = Math.round(sumDay*Number(params.turnover||0)*100)/100;
    const commPct = Number(rowData[id]?.['Комиссия на 1 ед.|#1a0d0d'] ?? params.commission ?? 0);
    const itogComm = price > 0 ? Math.round(price*commPct/100*100)/100 : 0;
    const commFbsPct = Number(rowData[id]?.['Комиссия на 1 ед.|#1a0f0f'] ?? 0);
    const itogCommFbs = price > 0 ? Math.round(price*commFbsPct/100*100)/100 : 0;
    const taxPct = Number(rowData[id]?.['% Налога|#160b0b'] ?? params.tax ?? 0);
    const itogTax = priceSpp > 0 ? Math.round(priceSpp*taxPct/100*100)/100 : 0;
    const profitNoRK = price > 0 ? Math.round((price - itogSeb - itogLog - itogHran - itogComm - itogTax)*100)/100 : null;
    const profitNoRKFbs = price > 0 ? Math.round((price - itogSeb - itogLog - itogHran - itogCommFbs - itogTax)*100)/100 : null;
    const marjaNoRK = price > 0 && profitNoRK != null ? Math.round(profitNoRK/price*10000)/100 : null;
    const marjaNoRKFbs = price > 0 && profitNoRKFbs != null ? Math.round(profitNoRKFbs/price*10000)/100 : null;
    return { price, priceSpp, cost, ff, itogSeb, vol, volN, logBase, vozvrat, buyout, il, koef, irp, deliv, itogLog, sumDay, itogHran, commPct, itogComm, commFbsPct, itogCommFbs, taxPct, itogTax, profitNoRK, profitNoRKFbs, marjaNoRK, marjaNoRKFbs };
  };

  // ─── Чистая прибыль ──────────────────────────────────────────────────────
  const calcNetProfit = (a, withRK) => {
    const ev = getEV(a);
    const id = String(a.nm_id);
    const manualDrr = rowData[id]?.['ДРР факт выкуп|#0a1e16'];
    const _drrFact = a.drr_fact;
    const drrVykupRaw = manualDrr != null ? Number(manualDrr) : (Number(_drrFact ?? 0) > 0 && ev.buyout > 0 ? Math.round((Number(_drrFact)/(ev.buyout/100))*100)/100 : 0);
    const drrVykup = withRK ? drrVykupRaw : 0;
    return ev.price > 0 ? Math.round((ev.price - ev.itogSeb - ev.itogLog - ev.itogHran - ev.itogComm - ev.itogTax - drrVykup)*100)/100 : null;
  };

  const calcNetProfitFbs = (a, withRK) => {
    const ev = getEV(a);
    const id = String(a.nm_id);
    const manualDrr = rowData[id]?.['ДРР факт выкуп|#0a1e16'];
    const _drrFact = a.drr_fact;
    const drrVykupRaw = manualDrr != null ? Number(manualDrr) : (Number(_drrFact ?? 0) > 0 && ev.buyout > 0 ? Math.round((Number(_drrFact)/(ev.buyout/100))*100)/100 : 0);
    const drrVykup = withRK ? drrVykupRaw : 0;
    return ev.price > 0 ? Math.round((ev.price - ev.itogSeb - ev.itogLog - ev.itogHran - ev.itogCommFbs - ev.itogTax - drrVykup)*100)/100 : null;
  };
  // ─── Данные ячейки ───────────────────────────────────────────────────────
  const getCellData = (a, col) => {
    const priceData = prices[String(a.nm_id)] || {};
    const id = String(a.nm_id);
    const ev = getEV(a);
    let cellVal = '', autoVal = null, isReadOnly = false;

    if (col.label === 'Себес.' && col.groupColor === '#1a1208') {
      const fromDB = costs[id] != null ? String(costs[id]) : null;
      const manual = rowData[id]?.['Себес.|' + col.groupColor];
      autoVal = fromDB !== null ? fromDB : '';
      cellVal = manual != null ? manual : autoVal;
    } else if (col.label === 'ФФ' && col.groupColor === '#1a1208') {
      autoVal = String(params.ff);
      const manual = rowData[id]?.['ФФ|' + col.groupColor];
      cellVal = manual != null ? manual : autoVal;
    } else if (col.label === 'Итог' && col.groupColor === '#1a1208') {
      cellVal = ev.itogSeb > 0 ? String(ev.itogSeb) : '';
      isReadOnly = true;
    } else if (col.label === 'Чистая прибыль' && col.groupColor === '#0a1a14') {
      const cp = calcNetProfit(a, false);
      autoVal = cp !== null ? String(cp) : null;
      const manual = rowData[id]?.['Чистая прибыль|' + col.groupColor];
      cellVal = manual != null ? manual : (autoVal !== null ? autoVal : '');
    } else if (col.label === 'Рента' && col.groupColor === '#0a1a14') {
      const cp = calcNetProfit(a, false);
      autoVal = ev.itogSeb > 0 && cp !== null ? String(Math.round(cp / ev.itogSeb * 100 * 100)/100) + '%' : null;
      const manual = rowData[id]?.['Рента|' + col.groupColor];
      cellVal = manual != null ? manual : (autoVal !== null ? autoVal : '');
    } else if (col.label === 'Маржа FBS' && col.groupColor === '#0a1a14') {
      const cpFbs = calcNetProfitFbs(a, false);
      const marjaFbs = cpFbs != null && ev.price > 0 ? Math.round(cpFbs/ev.price*10000)/100 : null;
      autoVal = marjaFbs != null ? String(marjaFbs) + '%' : null;
      cellVal = marjaFbs != null ? String(marjaFbs) + '%' : '';
      isReadOnly = true;
    } else if (col.label === 'Маржа' && col.groupColor === '#0a1a14') {
      const cp = calcNetProfit(a, false);
      autoVal = ev.price > 0 && cp !== null ? String(Math.round(cp / ev.price * 100 * 100)/100) + '%' : null;
      const manual = rowData[id]?.['Маржа|' + col.groupColor];
      cellVal = manual != null ? manual : (autoVal !== null ? autoVal : '');
    } else if (col.label === 'Чистая прибыль' && col.groupColor === '#091610') {
      const cp = calcNetProfit(a, true);
      autoVal = cp !== null ? String(cp) : null;
      const manual = rowData[id]?.['Чистая прибыль|' + col.groupColor];
      cellVal = manual != null ? manual : (autoVal !== null ? autoVal : '');
    } else if (col.label === 'Рента' && col.groupColor === '#091610') {
      const cp = calcNetProfit(a, true);
      autoVal = ev.itogSeb > 0 && cp !== null ? String(Math.round(cp / ev.itogSeb * 100 * 100)/100) + '%' : null;
      const manual = rowData[id]?.['Рента|' + col.groupColor];
      cellVal = manual != null ? manual : (autoVal !== null ? autoVal : '');
    } else if (col.label === 'Маржа FBS' && col.groupColor === '#091610') {
      const cpFbsRK = calcNetProfitFbs(a, true);
      const marjaFbsRK = cpFbsRK != null && ev.price > 0 ? Math.round(cpFbsRK/ev.price*10000)/100 : null;
      autoVal = marjaFbsRK != null ? String(marjaFbsRK) + '%' : null;
      cellVal = marjaFbsRK != null ? String(marjaFbsRK) + '%' : '';
      isReadOnly = true;
    } else if (col.label === 'Маржа' && col.groupColor === '#091610') {
      const cp = calcNetProfit(a, true);
      autoVal = ev.price > 0 && cp !== null ? String(Math.round(cp / ev.price * 100 * 100)/100) + '%' : null;
      const manual = rowData[id]?.['Маржа|' + col.groupColor];
      cellVal = manual != null ? manual : (autoVal !== null ? autoVal : '');
    } else if (col.label === 'Цена до СПП') {
      const fromDB = priceData.price != null ? String(priceData.price) : null;
      const manual = rowData[id]?.['Цена до СПП|' + col.groupColor];
      autoVal = fromDB !== null ? fromDB : '';
      cellVal = manual != null ? manual : autoVal;
    } else if (col.label === 'Цена с СПП') {
      const manualP = rowData[id]?.['Цена до СПП|#0d1526'];
      const actualSpp = priceData.spp_pct != null ? Number(priceData.spp_pct) : Number(params.spp);
      const sppVal = manualP != null ?
        Math.round(Number(manualP)*(1-actualSpp/100)*100)/100 :
        (priceData.price_spp != null ? Number(priceData.price_spp) :
        (priceData.price != null ? Math.round(Number(priceData.price)*(1-actualSpp/100)*100)/100 : 0));
      autoVal = sppVal > 0 ? String(sppVal) : '';
      const manual = rowData[id]?.['Цена с СПП|' + col.groupColor];
      cellVal = manual != null ? manual : autoVal;
    } else if (col.label === 'Стоимость возврата') {
      const manual = rowData[id]?.['Стоимость возврата|' + col.groupColor];
      autoVal = String(ev.logBase);
      cellVal = manual != null ? manual : autoVal;
    } else if (col.label === 'Процент выкупа') {
      const w1 = (a.buyout_avg ?? a.buyout_w1) != null ? String(a.buyout_avg ?? a.buyout_w1) : null;
      autoVal = w1 !== null ? w1 : '';
      const manual = rowData[id]?.['Процент выкупа|' + col.groupColor];
      cellVal = manual != null ? manual : autoVal;
    } else if (col.label === 'Логистика база') {
      const auto = calcLogBase(rowData[id]?.['Объём (л)|#130f1a'] ?? a.volume);
      const manual = rowData[id]?.['Логистика база|' + col.groupColor];
      autoVal = auto != null ? String(auto) : null;
      cellVal = manual != null ? manual : (autoVal !== null ? autoVal : '');
    } else if (col.label === 'Объём (л)') {
      const manual = rowData[id]?.['Объём (л)|' + col.groupColor];
      cellVal = manual != null ? manual : (a.volume != null ? String(a.volume) : '');
    } else if (col.label === 'ИРП') {
      cellVal = ev.price > 0 ? String(Math.round(ev.irp * 100) / 100) : '';
      isReadOnly = true;
    } else if (col.label === 'Итог' && col.groupColor === '#130f1a') {
      autoVal = String(ev.itogLog);
      const manual = rowData[id]?.['Итог|' + col.groupColor];
      cellVal = manual != null ? manual : autoVal;
    } else if (col.label === 'Доля логистики') {
      const val = ev.price > 0 && ev.itogLog > 0 ? String(Math.round(ev.itogLog / ev.price * 100 * 100)/100) + '%' : null;
      cellVal = val !== null ? val : '';
      isReadOnly = true;
    } else if (col.label === 'ДРР факт заказ') {
      const auto = (a.drr_fact) != null ? String(Math.round(Number(a.drr_fact) * 100) / 100) : null;
      autoVal = auto;
      const manual = rowData[id]?.['ДРР факт заказ|' + col.groupColor];
      cellVal = manual != null ? manual : (auto !== null ? auto : '');
    } else if (col.label === 'ДРР факт выкуп') {
      const drrZ = Number(a.drr_fact ?? 0);
      autoVal = drrZ > 0 && ev.buyout > 0 ? String(Math.round((drrZ / (ev.buyout/100)) * 100)/100) : null;
      const manual = rowData[id]?.['ДРР факт выкуп|' + col.groupColor];
      cellVal = manual != null ? manual : (autoVal !== null ? autoVal : '');
    } else if (col.label === 'Заказ' && col.groupColor === '#0f111a') {
      autoVal = ev.priceSpp > 0 ? String(Math.round(ev.priceSpp * Number(params.drr||5) / 100 * 100)/100) : null;
      const manual = rowData[id]?.['Заказ|' + col.groupColor];
      cellVal = manual != null ? manual : (autoVal !== null ? autoVal : '');
    } else if (col.label === 'Выкуп') {
      const drrZ = (() => {
        const manual = rowData[id]?.['Заказ|#0f111a'];
        return manual != null ? Number(manual) : (ev.priceSpp > 0 ? Math.round(ev.priceSpp * Number(params.drr||5) / 100 * 100)/100 : 0);
      })();
      autoVal = drrZ > 0 && ev.buyout > 0 ? String(Math.round((drrZ / ev.buyout) * 100 * 100)/100) : null;
      const manual = rowData[id]?.['Выкуп|' + col.groupColor];
      cellVal = manual != null ? manual : (autoVal !== null ? autoVal : '');
    } else if (col.label === 'Сумма на 1 ед. (в день)') {
      const volN = Number(rowData[id]?.['Объём (л)|#130f1a'] ?? a.volume);
      const base = Number(params.storageBase || 0);
      const extra = Number(params.storageExtra || 0);
      const auto = volN > 0 ? (volN > 1 ? Math.round((base+(volN-1)*extra)*1000)/1000 : Math.round(base*1000)/1000) : null;
      autoVal = auto !== null ? String(auto) : null;
      const manual = rowData[id]?.['Сумма на 1 ед. (в день)|' + col.groupColor];
      cellVal = manual != null ? manual : (autoVal !== null ? autoVal : '');
    } else if (col.label === 'Итог' && col.groupColor === '#0b1220') {
      autoVal = String(ev.itogHran);
      const manual = rowData[id]?.['Итог|' + col.groupColor];
      cellVal = manual != null ? manual : autoVal;
    } else if (col.label === 'Комиссия на 1 ед.' && col.groupColor === '#1a0f0f') {
      const manual = rowData[id]?.['Комиссия на 1 ед.|#1a0f0f'];
      autoVal = manual != null ? null : '';
      cellVal = manual != null ? manual : '';
    } else if (col.label === 'Комиссия на 1 ед.') {
      const manual = rowData[id]?.['Комиссия на 1 ед.|' + col.groupColor];
      autoVal = manual != null ? null : String(params.commission);
      cellVal = manual != null ? manual : String(params.commission);
    } else if (col.label === 'Итог' && col.groupColor === '#1a0f0f') {
      autoVal = ev.itogCommFbs > 0 ? String(ev.itogCommFbs) : null;
      cellVal = ev.itogCommFbs > 0 ? String(ev.itogCommFbs) : '';
    } else if (col.label === 'Итог' && col.groupColor === '#1a0d0d') {
      autoVal = ev.itogComm > 0 ? String(ev.itogComm) : null;
      const manual = rowData[id]?.['Итог|' + col.groupColor];
      cellVal = manual != null ? manual : (autoVal !== null ? autoVal : '');
    } else if (col.label === '% Налога') {
      autoVal = String(params.tax);
      const manual = rowData[id]?.['% Налога|' + col.groupColor];
      cellVal = manual != null ? manual : autoVal;
    } else if (col.label === 'Итог' && col.groupColor === '#160b0b') {
      autoVal = ev.itogTax > 0 ? String(ev.itogTax) : null;
      const manual = rowData[id]?.['Итог|' + col.groupColor];
      cellVal = manual != null ? manual : (autoVal !== null ? autoVal : '');
    } else {
      const globalDefault = getGlobalDefault(col.label, col.groupColor);
      const manual = rowData[id]?.[col.label + '|' + col.groupColor];
      if (manual != null) cellVal = manual;
      else if (globalDefault !== null) { cellVal = globalDefault; autoVal = globalDefault; }
    }
    // Округляем до целых для всех колонок кроме Объём (л), Логистика база, Процент выкупа, Сумма на 1 ед.
    const noRound = ['Объём (л)', 'Сумма на 1 ед. (в день)', 'ИРП', 'Маржа', 'Маржа FBS', 'ДРР факт заказ', 'ДРР факт выкуп', 'Комиссия на 1 ед.'];
    if (!noRound.includes(col.label) && cellVal !== '' && !isNaN(parseFloat(cellVal))) {
      const numVal = parseFloat(cellVal);
      const hasPct = String(cellVal).includes('%');
      cellVal = String(Math.round(numVal)) + (hasPct ? '%' : '');
    }
    return { cellVal, autoVal, isReadOnly };
  };

  // ─── Сохранение расчётных значений в unit_calculated ────────────────────
  useEffect(() => {
    if (!articles.length || !paramsLoaded) return;
    const timer = setTimeout(() => {
      const CALC_COLS = [
        { label: 'Итог', groupColor: '#1a1208' },
        { label: 'Итог', groupColor: '#130f1a' },
        { label: 'Итог', groupColor: '#0b1220' },
        { label: 'Итог', groupColor: '#1a0d0d' },
        { label: 'Итог', groupColor: '#1a0f0f' },
        { label: 'Итог', groupColor: '#160b0b' },
        { label: 'Чистая прибыль', groupColor: '#0a1a14' },
        { label: 'Чистая прибыль', groupColor: '#091610' },
        { label: 'Маржа', groupColor: '#0a1a14' },
        { label: 'Маржа', groupColor: '#091610' },
      ];
      const rows = [];
      articles.forEach(a => {
        CALC_COLS.forEach(col => {
          const { cellVal } = getCellData(a, col);
          if (cellVal && cellVal !== '') {
            rows.push({ nmId: a.nm_id, cellKey: col.label + '|' + col.groupColor, cellValue: parseFloat(String(cellVal).replace('%','')) || 0 });
          }
        });
      });
      if (rows.length > 0) {
        const batchSize = 50;
        for (let i = 0; i < rows.length; i += batchSize) {
          api.post('/monitoring/unit-calculated', { rows: rows.slice(i, i + batchSize) }).catch(() => {});
        }
      }
    }, 3000);
    return () => clearTimeout(timer);
  }, [articles, rowData, params]);

  const fmtDate = (d) => {
    if (!d) return null;
    const dt = new Date(d);
    if (isNaN(dt)) return null;
    const now = new Date();
    const diff = Math.floor((now - dt) / 86400000);
    const str = dt.toLocaleString('ru-RU', {day:'2-digit',month:'2-digit',year:'2-digit',hour:'2-digit',minute:'2-digit'});
    if (diff === 0) return str + ' (сегодня)';
    if (diff === 1) return str + ' (вчера)';
    if (diff > 7) return str + ' ⚠️ ' + diff + ' дн. назад';
    return str + ' (' + diff + ' дн. назад)';
  };

  // ─── Подсказки для ячеек ─────────────────────────────────────────────────
  const getTooltip = (a, col, cellVal, autoVal, manualVal, globalDefault) => {
    const id = String(a.nm_id);
    const priceData = prices[id] || {};
    const ev = getEV(a);
    const lines = [];

    if (col.label === 'Себес.' && col.groupColor === '#1a1208') {
      const fromDB = costs[id];
      if (manualVal != null) lines.push('✏️ Вручную: ' + manualVal);
      if (fromDB != null) lines.push('📁 Из файла импорта: ' + fromDB);
      else lines.push('📁 Файл себестоимости: не загружен');
    } else if (col.label === 'Процент выкупа') {
      if (manualVal != null) lines.push('✏️ Изменено вручную: ' + manualVal + '%');
      lines.push('🔄 Обновляется каждый понедельник в 11:00 МСК');
      lines.push('W1: ' + (a.buyout_w1 ?? '—') + '%  W2: ' + (a.buyout_w2 ?? '—') + '%  W3: ' + (a.buyout_w3 ?? '—') + '%  W4: ' + (a.buyout_w4 ?? '—') + '%');
      lines.push('Среднее (без нулей): ' + (a.buyout_avg ?? '—') + '%');
    } else if (col.label === 'ДРР факт заказ') {
      lines.push('🔄 Обновляется каждый понедельник в 11:00 МСК');
      lines.push('Формула: Затраты / Кол-во заказов');
      const useCurrentWeek = a.current_week_spend != null && a.current_week_orders > 0;
      const spend = useCurrentWeek ? a.current_week_spend : a.total_spend;
      const orders = useCurrentWeek ? a.current_week_orders : a.total_orders_qty;
      const pFrom = useCurrentWeek ? a.current_week_from : a.period_from;
      const pTo = useCurrentWeek ? a.current_week_to : a.period_to;
      const cpo = useCurrentWeek
        ? Math.round(Number(a.current_week_spend) / Number(a.current_week_orders) * 100) / 100
        : ((a.drr_fact) != null ? Math.round(Number(a.drr_fact)*100)/100 : null);
      if (spend != null) lines.push('Затраты: ' + Math.round(Number(spend)) + ' ₽');
      if (orders != null) lines.push('Заказов: ' + orders + ' шт.');
      if (pFrom && pTo) lines.push('Период: ' + String(pFrom).split('T')[0] + ' — ' + String(pTo).split('T')[0]);
      lines.push('Результат: ' + (cpo != null ? cpo : '—') + ' ₽/заказ');
      if (useCurrentWeek) lines.push('⚡ Текущая неделя (обновляется ежедневно)');
      if (manualVal != null) lines.push('✏️ Вручную: ' + manualVal);
    } else if (col.label === 'ДРР факт выкуп') {
      const drrZ = Number(a.drr_fact ?? 0);
      const autoResult = drrZ > 0 && ev.buyout > 0 ? Math.round((drrZ / (ev.buyout/100)) * 100)/100 : null;
      lines.push('ДРР факт заказ: ' + (drrZ > 0 ? Math.round(drrZ*100)/100 : '—') + ' ₽');
      lines.push('% выкупа: ' + ev.buyout + '%');
      lines.push('Авто: ' + Math.round(drrZ*100)/100 + ' / ' + ev.buyout + '% × 100 = ' + (autoResult ?? '—') + ' ₽');
      if (manualVal != null) lines.push('✏️ Вручную: ' + manualVal + ' (используется в расчёте)');
    } else if (col.label === 'Итог' && col.groupColor === '#1a1208') {
      lines.push('Себес.: ' + ev.cost + ' ₽  +  ФФ: ' + ev.ff + ' ₽');
      lines.push('Результат: ' + ev.itogSeb + ' ₽');
    } else if (col.label === 'Логистика база') {
      const vol = rowData[id]?.['Объём (л)|#130f1a'] ?? a.volume;
      const volN = Number(vol);
      lines.push('Объём: ' + (vol ?? '—') + ' л');
      if (manualVal != null) {
        lines.push('✏️ Вручную: ' + manualVal + ' ₽');
      } else {
        const auto = calcLogBase(vol);
        if (volN > 1) lines.push('Тариф: ' + params.logBase + ' + (' + volN.toFixed(3) + '-1) × ' + params.logExtra + ' = ' + (auto ?? '—') + ' ₽');
        else lines.push('Тариф по сетке: ' + (auto ?? '—') + ' ₽');
      }
    } else if (col.label === 'Итог' && col.groupColor === '#130f1a') {
      lines.push('% выкупа: ' + ev.buyout + '%');
      lines.push('Логистика база: ' + ev.logBase + ' ₽');
      lines.push('ИЛ: ' + ev.il + '  Коэф склада: ' + ev.koef + '  ИРП: ' + ev.irp + ' ₽');
      const deliv = Math.round(ev.deliv*100)/100;
      lines.push('Формула: (100-' + ev.buyout + ')×(' + ev.logBase + '+' + deliv + ')/' + ev.buyout + '+' + deliv);
      lines.push('Результат: ' + ev.itogLog + ' ₽');
    } else if (col.label === 'Объём (л)') {
      const manual = rowData[id]?.['Объём (л)|#130f1a'];
      if (manual != null) lines.push('✏️ Вручную в таблице: ' + manual + ' л');
      else if (a.volume != null) lines.push('📁 Из Excel импорта: ' + a.volume + ' л');
      else lines.push('⚠️ Объём не заполнен — загрузите через Импорт объёмов');
    } else if (col.label === 'Стоимость возврата') {
      lines.push('Стоимость возврата = Логистика база');
      lines.push('Объём: ' + (ev.vol ?? '—') + ' л');
      if (manualVal != null) lines.push('✏️ Вручную: ' + manualVal + ' ₽');
      else lines.push('Авто: ' + ev.logBase + ' ₽');
    } else if (col.label === 'Цена до СПП') {
      if (manualVal != null) lines.push('✏️ Вручную: ' + manualVal);
      if (priceData.price != null) lines.push('📡 Из WB API: ' + priceData.price + ' ₽');
      else lines.push('⚠️ Цена не загружена');
      if (manualVal != null) lines.push('✏️ Изменено вручную: ' + fmtDate(rowData[id]?.['Цена до СПП|#0d1526__updated_at']));
    } else if (col.label === 'Цена с СПП') {
      if (priceData.price_spp != null) {
        lines.push('📡 Из WB API: ' + priceData.price_spp + ' ₽');
        lines.push('СПП: ' + priceData.spp_pct + '%');
      } else {
        lines.push('⚠️ Нет данных СПП от WB');
        lines.push('Глобальный параметр СПП: ' + params.spp + '%');
      }
      if (manualVal != null) lines.push('✏️ Изменено вручную: ' + manualVal);
    } else if (col.label === 'Доля логистики') {
      lines.push('Итог логистики: ' + ev.itogLog + ' ₽');
      lines.push('Цена до СПП: ' + ev.price + ' ₽');
      lines.push(ev.itogLog + ' / ' + ev.price + ' × 100 = ' + cellVal);
    } else if (col.label === 'Итог' && col.groupColor === '#0b1220') {
      lines.push('Сумма хранения в день: ' + ev.sumDay + ' ₽');
      lines.push('Оборачиваемость: ' + params.turnover + ' дн.');
      lines.push(ev.sumDay + ' × ' + params.turnover + ' = ' + ev.itogHran + ' ₽');
      if (manualVal != null) lines.push('✏️ Вручную: ' + manualVal);
    } else if (col.label === 'Сумма на 1 ед. (в день)') {
      const volN = Number(ev.vol);
      lines.push('Объём: ' + (ev.vol ?? '—') + ' л');
      lines.push('Базовая стоимость хранения: ' + params.storageBase + ' ₽/л');
      if (volN > 1) lines.push(params.storageBase + ' + (' + volN + '-1) × ' + params.storageExtra + ' = ' + ev.sumDay + ' ₽/день');
      else lines.push(params.storageBase + ' × ' + volN + ' = ' + ev.sumDay + ' ₽/день');
      if (manualVal != null) lines.push('✏️ Вручную: ' + manualVal);
    } else if (col.label === 'Итог' && col.groupColor === '#1a0d0d') {
      lines.push('Цена до СПП: ' + ev.price + ' ₽');
      lines.push('Комиссия: ' + ev.commPct + '%');
      lines.push(ev.price + ' × ' + ev.commPct + ' / 100 = ' + ev.itogComm + ' ₽');
      if (manualVal != null) lines.push('✏️ Вручную: ' + manualVal);
    } else if (col.label === 'Итог' && col.groupColor === '#160b0b') {
      lines.push('Цена с СПП: ' + ev.priceSpp + ' ₽');
      lines.push('% Налога: ' + ev.taxPct + '%');
      lines.push(ev.priceSpp + ' × ' + ev.taxPct + ' / 100 = ' + ev.itogTax + ' ₽');
      if (manualVal != null) lines.push('✏️ Вручную: ' + manualVal);
    } else if (col.label === 'Чистая прибыль' && col.groupColor === '#0a1a14') {
      const cp = calcNetProfit(a, false);
      lines.push('Цена до СПП: ' + ev.price + ' ₽');
      lines.push('- Себес+ФФ: ' + ev.itogSeb + ' ₽');
      lines.push('- Логистика: ' + ev.itogLog + ' ₽');
      lines.push('- Хранение: ' + ev.itogHran + ' ₽');
      lines.push('- Комиссия: ' + ev.itogComm + ' ₽');
      lines.push('- Налог: ' + ev.itogTax + ' ₽');
      lines.push('= ' + (cp ?? '—') + ' ₽');
      if (manualVal != null) lines.push('✏️ Вручную: ' + manualVal);
    } else if (col.label === 'Чистая прибыль' && col.groupColor === '#091610') {
      const cp = calcNetProfit(a, true);
      const manualDrrT = rowData[String(a.nm_id)]?.['ДРР факт выкуп|#0a1e16'];
      const drrVykup = manualDrrT != null ? Number(manualDrrT) : (Number(a.drr_fact ?? 0) > 0 && ev.buyout > 0 ? Math.round((Number(a.drr_fact)/ev.buyout)*100*100)/100 : 0);
      lines.push('Цена до СПП: ' + ev.price + ' ₽');
      lines.push('- Себес+ФФ: ' + ev.itogSeb + ' ₽');
      lines.push('- Логистика: ' + ev.itogLog + ' ₽');
      lines.push('- Хранение: ' + ev.itogHran + ' ₽');
      lines.push('- Комиссия: ' + ev.itogComm + ' ₽');
      lines.push('- Налог: ' + ev.itogTax + ' ₽');
      lines.push('- ДРР факт выкуп: ' + drrVykup + ' ₽');
      lines.push('= ' + (cp ?? '—') + ' ₽');
      if (manualVal != null) lines.push('✏️ Вручную: ' + manualVal);
    } else if (col.label === 'Рента') {
      const withRK = col.groupColor === '#091610';
      const cp = calcNetProfit(a, withRK);
      const renta = ev.itogSeb > 0 && cp !== null ? Math.round(cp / ev.itogSeb * 100 * 100)/100 : null;
      lines.push('Себес+ФФ: ' + ev.itogSeb + ' ₽');
      lines.push('Чистая прибыль ' + (withRK ? 'с РК' : 'без РК') + ': ' + (cp ?? '—') + ' ₽');
      lines.push(cp + ' / ' + ev.itogSeb + ' × 100 = ' + (renta ?? '—') + '%');
      if (manualVal != null) lines.push('✏️ Вручную: ' + manualVal);
    } else if (col.label === 'Маржа') {
      const withRK = col.groupColor === '#091610';
      const cp = calcNetProfit(a, withRK);
      const marja = ev.price > 0 && cp !== null ? Math.round(cp / ev.price * 100 * 100)/100 : null;
      lines.push('Чистая прибыль ' + (withRK ? 'с РК' : 'без РК') + ': ' + (cp ?? '—') + ' ₽');
      lines.push('Цена до СПП: ' + ev.price + ' ₽');
      lines.push(cp + ' / ' + ev.price + ' × 100 = ' + (marja ?? '—') + '%');
      if (manualVal != null) lines.push('✏️ Вручную: ' + manualVal);
    } else if (col.label === 'Заказ' && col.groupColor === '#0f111a') {
      lines.push('Цена с СПП: ' + ev.priceSpp + ' ₽');
      lines.push('ДРР%: ' + params.drr + '%');
      lines.push(ev.priceSpp + ' × ' + params.drr + ' / 100 = ' + (autoVal ?? '—') + ' ₽');
      if (manualVal != null) lines.push('✏️ Вручную: ' + manualVal);
    } else if (col.label === 'Выкуп') {
      const drrZ = rowData[id]?.['Заказ|#0f111a'] != null ? Number(rowData[id]['Заказ|#0f111a']) : (ev.priceSpp > 0 ? Math.round(ev.priceSpp * Number(params.drr||5) / 100 * 100)/100 : 0);
      lines.push('ДРР заказ: ' + drrZ + ' ₽');
      lines.push('% выкупа: ' + ev.buyout + '%');
      lines.push(drrZ + ' / ' + ev.buyout + ' = ' + (autoVal ?? '—'));
      if (manualVal != null) lines.push('✏️ Вручную: ' + manualVal);
    } else if (globalDefault !== null) {
      lines.push('Глобальный параметр: ' + globalDefault);
      if (manualVal != null) lines.push('✏️ Вручную: ' + manualVal);
    } else if (autoVal !== null) {
      lines.push('Авто: ' + autoVal);
    }
    return lines.join('\n');
  };

  const hiddenCount = articles.filter(a => a.is_hidden).length;
  const visibleArticles = articles.filter(a => {
    if (showHidden) return a.is_hidden;
    if (a.is_hidden) return false;
    if (filterTag === 'top') return a.tag === 'top';
    if (filterTag === 'flop') return a.tag === 'flop';
    if (search) {
      const s = search.toLowerCase();
      return (a.vendor_code||'').toLowerCase().includes(s) || String(a.nm_id).includes(search);
    }
    return true;
  });

  return (
    <div style={{ padding:'24px 24px 40px', minHeight:'100vh', background:'#0a0f1a' }}>

      {/* Заголовок */}
      <div style={{ marginBottom:16, display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:12 }}>
        <div>
          <h1 style={{ fontSize:20, fontWeight:700, color:'#fff', letterSpacing:'-0.5px' }}>Юнит-экономика</h1>
          <div style={{display:'flex',alignItems:'center',gap:4,marginTop:4}}>
            <button onClick={()=>{if(history.length>0&&historyIdx>=0){const snap=history[historyIdx];setRowData(snap.rowData);if(snap.articles)setArticles(snap.articles);if(snap.params)setParams(snap.params);setHistoryIdx(i=>i-1);}}} disabled={historyIdx<0} title="Отменить (Ctrl+Z)" style={{background:'rgba(59,130,246,0.2)',border:'1px solid rgba(59,130,246,0.5)',color:'#60a5fa',fontSize:13,padding:'3px 8px',borderRadius:5,cursor:historyIdx>=0?'pointer':'default'}}>↩</button>
            <button onClick={()=>{const snap=history[historyIdx+1];if(snap){setRowData(snap.rowData);if(snap.articles)setArticles(snap.articles);if(snap.params)setParams(snap.params);setHistoryIdx(i=>i+1);}}} disabled={historyIdx>=history.length-1} title="Вернуть (Ctrl+Shift+Z)" style={{background:'rgba(59,130,246,0.2)',border:'1px solid rgba(59,130,246,0.5)',color:'#60a5fa',fontSize:13,padding:'3px 8px',borderRadius:5,cursor:historyIdx<history.length-1?'pointer':'default'}}>↪</button>
          </div>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Поиск по артикулу..."
            style={{marginTop:6,padding:'4px 10px',fontSize:11,borderRadius:6,border:'1px solid rgba(255,255,255,0.12)',background:'rgba(255,255,255,0.04)',color:'#fff',outline:'none',width:200}}/>
        </div>
        <input type="file" accept=".xlsx" ref={fileRef} style={{display:'none'}} onChange={handleImportVolumes}/>
        <input type="file" accept=".xlsx" ref={costFileRef} style={{display:'none'}} onChange={handleImportCost}/>
        <input type="file" accept=".xlsx" ref={commFileRef} style={{display:'none'}} onChange={handleImportCommission}/>
        <div style={{display:'flex', gap:4, alignItems:'center', flexWrap:'wrap'}}>
          <span style={{fontSize:11, color:'rgba(200,215,235,0.4)'}}>
            {showHidden ? `скрытые: ${hiddenCount} арт.` : `${visibleArticles.length} арт.`}
          </span>
          {hiddenCount > 0 && <button onClick={()=>setShowHidden(s=>!s)} style={{
            padding:'3px 10px', fontSize:11, borderRadius:6, cursor:'pointer', fontWeight: showHidden ? 700 : 400,
            background: showHidden ? 'rgba(239,68,68,0.2)' : 'rgba(255,255,255,0.04)',
            border: showHidden ? '1px solid rgba(239,68,68,0.5)' : '1px solid rgba(255,255,255,0.12)',
            color: showHidden ? '#ef4444' : 'rgba(200,215,235,0.5)',
          }}>{showHidden ? `✕ скрыть (${hiddenCount})` : `○ скрытые (${hiddenCount})`}</button>}
          {[
            {k:'all',  label:'★ Все',  count: articles.filter(a=>!a.is_hidden).length, bg:'rgba(59,130,246,0.2)',  border:'rgba(59,130,246,0.5)',  color:'#60a5fa'},
            {k:'top',  label:'▲ Топ',  count: articles.filter(a=>a.tag==='top').length,  bg:'rgba(16,185,129,0.2)', border:'rgba(16,185,129,0.5)', color:'#10b981'},
            {k:'flop', label:'▼ Слив', count: articles.filter(a=>a.tag==='flop').length, bg:'rgba(239,68,68,0.2)',  border:'rgba(239,68,68,0.5)',  color:'#ef4444'},
          ].map(f => (
            <button key={f.k} onClick={()=>setFilterTag(f.k)} style={{
              padding:'6px 16px', fontSize:12, fontWeight: filterTag===f.k ? 700 : 400,
              borderRadius:8, cursor:'pointer',
              background: filterTag===f.k ? f.bg : 'rgba(255,255,255,0.04)',
              border: filterTag===f.k ? `1px solid ${f.border}` : '1px solid rgba(255,255,255,0.15)',
              color: filterTag===f.k ? f.color : 'rgba(200,215,235,0.6)',
            }}>{f.label}{f.count > 0 ? ` (${f.count})` : ''}</button>
          ))}
        </div>
        <button onClick={()=>fileRef.current.click()} title="Файл Excel (.xlsx)&#10;Лист 1, строки со 2-й:&#10;• Колонка E — Артикул WB (nm_id)&#10;• Колонка H — Объём, л.&#10;&#10;Пример: скачай отчёт по товарам из WB,&#10;там уже есть нужные колонки." style={{ background:'rgba(59,130,246,0.15)', border:'1px solid rgba(59,130,246,0.3)', color:'#60a5fa', fontSize:12, padding:'7px 16px', borderRadius:8, cursor:'pointer' }}>
          {importing ? '⟳ Импорт...' : '+ Импорт объёмов'}
        </button>
        <button onClick={()=>costFileRef.current.click()} title="Файл Excel (.xlsx)&#10;Лист 1, строки со 2-й:&#10;• Колонка A — Артикул WB (nm_id)&#10;• Колонка C — Размер (оставь пустым для общей себестоимости)&#10;• Колонка D — Себестоимость, ₽&#10;&#10;Строки с заполненным размером игнорируются —&#10;берётся только строка без размера." style={{ background:'rgba(16,185,129,0.15)', border:'1px solid rgba(16,185,129,0.3)', color:'#10b981', fontSize:12, padding:'7px 16px', borderRadius:8, cursor:'pointer' }}>
          {importingCost ? '⟳ Импорт...' : '+ Импорт себеса'}
        </button>
        <button onClick={()=>commFileRef.current.click()} title="Файл Excel (.xlsx)&#10;Лист 1, строки со 2-й:&#10;• Колонка B — Предмет (например: Платья, Костюмы)&#10;• Колонка C — Комиссия, %&#10;&#10;Комиссия подставляется всем товарам&#10;у которых совпадает поле Предмет из WB." style={{ background:'rgba(168,85,247,0.15)', border:'1px solid rgba(168,85,247,0.3)', color:'#a855f7', fontSize:12, padding:'7px 16px', borderRadius:8, cursor:'pointer' }}>
          {importingComm ? '⟳ Импорт...' : '+ Импорт комиссий'}
        </button>
        <button onClick={()=>commFbsFileRef.current.click()} title="Файл Excel (.xlsx) — комиссии FBS&#10;Лист 1, строки со 2-й:&#10;• Колонка B — Предмет&#10;• Колонка C — Комиссия FBS, %" style={{ background:'rgba(245,158,11,0.15)', border:'1px solid rgba(245,158,11,0.3)', color:'#f59e0b', fontSize:12, padding:'7px 16px', borderRadius:8, cursor:'pointer' }}>
          {importingCommFbs ? '⟳ Импорт...' : '+ Импорт комиссий FBS'}
        </button>
        <input ref={commFbsFileRef} type="file" accept=".xlsx" style={{display:'none'}} onChange={handleImportCommissionFbs}/>
        <button onClick={()=>window.location.reload(true)} style={{ background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.1)", color:"rgba(200,215,235,0.5)", fontSize:12, padding:"7px 16px", borderRadius:8, cursor:"pointer" }}>↺ Сбросить кэш</button>
      </div>

      {/* Глобальные параметры */}
      <div style={{ background:'rgba(8,14,25,0.7)', border:'1px solid rgba(255,255,255,0.07)', borderRadius:12, padding:'12px 16px', marginBottom:16, display:'flex', flexWrap:'wrap', gap:8, alignItems:'center' }}>
        <span style={{ fontSize:11, color:'rgba(200,215,235,0.4)', marginRight:4, letterSpacing:'0.5px', textTransform:'uppercase' }}>Параметры:</span>
        <GlobalParam label="ФФ"                      value={params.ff}         onChange={set('ff')}         suffix="₽" />
        <GlobalParam label="Стандарт маржинальности" value={params.stdMargin}  onChange={set('stdMargin')}  suffix="%" />
        <GlobalParam label="ИЛ"                      value={params.coef1}      onChange={set('coef1')}      suffix="" />
        <GlobalParam label="ИРП"                     value={params.irp}        onChange={set('irp')}        suffix="" />
        <GlobalParam label="ДРР"                     value={params.drr}        onChange={set('drr')}        suffix="%" />
        <GlobalParam label="Оборачиваемость"         value={params.turnover}   onChange={set('turnover')}   suffix="дн" />
        <GlobalParam label="Налог"                   value={params.tax}        onChange={set('tax')}        suffix="%" />
        <GlobalParam label="Коэф склада"             value={params.coefSklad}  onChange={set('coefSklad')}  suffix="" />
      </div>

      {/* Логистика и Хранение */}
      <div style={{ background:'rgba(8,14,25,0.7)', border:'1px solid rgba(255,255,255,0.07)', borderRadius:12, padding:'12px 16px', marginBottom:16, display:'flex', flexWrap:'wrap', gap:16, alignItems:'center' }}>
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <span style={{ fontSize:11, color:'rgba(200,215,235,0.4)', letterSpacing:'0.5px', textTransform:'uppercase' }}>Логистика:</span>
          <GlobalParam label="Базовая стоимость литра" value={params.logBase}    onChange={set('logBase')}    suffix="₽" />
          <GlobalParam label="Цена за доп литр"        value={params.logExtra}   onChange={set('logExtra')}   suffix="₽" />
        </div>
        <div style={{ width:1, height:28, background:'rgba(255,255,255,0.07)' }}/>
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <span style={{ fontSize:11, color:'rgba(200,215,235,0.4)', letterSpacing:'0.5px', textTransform:'uppercase' }}>Хранение:</span>
          <GlobalParam label="Базовая стоимость литра" value={params.storageBase}  onChange={set('storageBase')}  suffix="₽" />
          <GlobalParam label="Цена за доп литр"        value={params.storageExtra} onChange={set('storageExtra')} suffix="₽" />
        </div>
      </div>

      {/* Таблица */}
      <div style={{ opacity: paramsLoaded ? 1 : 0, transition:'opacity 0.2s' }}>
      <div style={{ background:'#0a0f1a', border:'1px solid rgba(255,255,255,0.12)', borderRadius:12, overflow:'auto', maxHeight:'calc(100vh - 280px)' }}>
        <div style={{ minWidth: TOTAL_W }}>

          {/* Шапка строка 1 */}
          <div style={{ display:'flex', position:'sticky', top:0, zIndex:4, background:'#0a0f1a' }}>
            {FIXED_COLS.map((col, ci) => (
              <div key={ci} style={{
                width: col.w, minWidth: col.w, flexShrink:0, height: HEAD1_H,
                position:'sticky', left: FIXED_LEFTS[ci], zIndex:5, background: FIXED_BG,
                display:'flex', alignItems:'center', justifyContent:'center',
                borderBottom:'1px solid rgba(255,255,255,0.06)',
                borderRight: ci === FIXED_COLS.length-1 ? '2px solid rgba(255,255,255,0.18)' : '1px solid rgba(255,255,255,0.05)',
                fontSize: ci === 0 ? 11 : 10, fontWeight:600, color:'rgba(200,215,235,0.75)', boxSizing:'border-box',
              }}>
                {ci === 0 ? 'Наименование' : ''}
              </div>
            ))}
            {SCROLL_GROUPS.map((g, gi) => {
              const gw = g.cols.reduce((a,b) => a+b.w, 0);
              return (
                <div key={gi} style={{
                  width: gw, minWidth: gw, flexShrink:0, height: HEAD1_H,
                  display:'flex', alignItems:'center', justifyContent:'center',
                  background: g.color, borderRight:'1px solid rgba(255,255,255,0.07)',
                  borderBottom:'1px solid rgba(255,255,255,0.06)',
                  fontSize:11, fontWeight:600, color: g.accent || 'rgba(200,215,235,0.7)',
                  whiteSpace:'nowrap', boxSizing:'border-box',
                }}>
                  {g.label}
                </div>
              );
            })}
          </div>

          {/* Шапка строка 2 */}
          <div style={{ display:'flex', position:'sticky', top: HEAD1_H, zIndex:4, background:'#0a0f1a' }}>
            {FIXED_COLS.map((col, ci) => (
              <div key={ci} style={{
                width: col.w, minWidth: col.w, flexShrink:0, height: HEAD2_H,
                position:'sticky', left: FIXED_LEFTS[ci], zIndex:5, background: FIXED_BG,
                display:'flex', alignItems:'center', justifyContent:'center',
                borderBottom:'1px solid rgba(255,255,255,0.08)',
                borderRight: ci === FIXED_COLS.length-1 ? '2px solid rgba(255,255,255,0.18)' : '1px solid rgba(255,255,255,0.05)',
                fontSize:10, fontWeight:500, color:'rgba(200,215,235,0.5)', boxSizing:'border-box',
              }}>
                {col.label}
              </div>
            ))}
            {SCROLL_COLS.map((col, ci) => (
              <div key={ci} style={{
                width: col.w, minWidth: col.w, flexShrink:0, height: HEAD2_H,
                display:'flex', alignItems:'center', justifyContent:'center',
                background: col.groupColor, borderRight:'1px solid rgba(255,255,255,0.04)',
                borderBottom:'1px solid rgba(255,255,255,0.08)',
                fontSize:10, fontWeight:500, color: col.groupAccent || 'rgba(200,215,235,0.5)',
                whiteSpace:'nowrap', padding:'0 6px', boxSizing:'border-box',
              }}>
                {col.label}
              </div>
            ))}
          </div>

          {/* Строки данных */}
          {loading && (
            <div style={{ height:ROW_H, display:'flex', alignItems:'center', justifyContent:'center', color:'rgba(200,215,235,0.25)', fontSize:13 }}>
              Загружаем...
            </div>
          )}
          {!loading && visibleArticles.length === 0 && (
            <div style={{ height:ROW_H, display:'flex', alignItems:'center', justifyContent:'center', color:'rgba(200,215,235,0.25)', fontSize:13 }}>
              Нет данных
            </div>
          )}
          {visibleArticles.map((a, idx) => {
            const rowBg = idx % 2 === 0 ? FIXED_BG : '#0f1825';
            return (
              <div key={a.nm_id}>
              <div style={{ display:'flex', borderBottom:'1px solid rgba(255,255,255,0.12)' }}> {/* строка артикула */}
                {/* Фото */}
                <div style={{ width:FIXED_COLS[0].w, minWidth:FIXED_COLS[0].w, flexShrink:0, height:ROW_H,
                  position:'sticky', left:FIXED_LEFTS[0], zIndex:2, background:rowBg,
                  display:'flex', alignItems:'center', justifyContent:'center',
                  borderRight:'1px solid rgba(255,255,255,0.05)', boxSizing:'border-box' }}>
                  {a.photo
                    ? <img src={a.photo} alt="" className="wb-photo" style={{width:36,height:36,objectFit:'cover',borderRadius:4}}/>
                    : <div style={{width:36,height:36,background:'rgba(255,255,255,0.05)',borderRadius:4}}/>}
                  <button onClick={()=>setOpenDrafts(s=>({...s,[a.nm_id]:!s[a.nm_id]}))}
                    title="Черновик"
                    style={{position:'absolute',bottom:2,right:2,background:'transparent',border:'none',cursor:'pointer',fontSize:10,color:'rgba(99,102,241,0.7)',padding:0,lineHeight:1}}>
                    {openDrafts[a.nm_id]?'▲':'▼'}
                  </button>
                </div>
                {/* Артикул продавца */}
                <div style={{ width:FIXED_COLS[1].w, minWidth:FIXED_COLS[1].w, flexShrink:0, height:ROW_H,
                  position:'sticky', left:FIXED_LEFTS[1], zIndex:2, background:rowBg,
                  borderRight:'1px solid rgba(255,255,255,0.05)', boxSizing:'border-box', display:'flex', alignItems:'center' }}>
                  <div style={{padding:'0 8px', width:'100%', overflow:'hidden'}}>
                    <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                      <div title={a.vendor_code} style={{fontWeight:600,color:'#fff',fontSize:11,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',flex:1,cursor:'help'}}>
                        {a.vendor_code}
                      </div>
                      <button onClick={()=>toggleHidden(a.nm_id)} style={{flexShrink:0,background:'transparent',border:'none',cursor:'pointer',fontSize:10,color:'rgba(239,68,68,0.5)',padding:'0 2px',lineHeight:1}}>✕</button>
                    </div>
                    <div style={{display:'flex',alignItems:'center',gap:4,marginTop:1}}>
                      <span style={{color:'rgba(200,215,235,0.4)',fontSize:9,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',flex:1}}>{a.name}</span>
                      <span onClick={()=>handleTag(a.nm_id)} style={{
                        flexShrink:0, fontSize:9, cursor:'pointer', borderRadius:3, padding:'1px 4px',
                        background: a.tag==='top'?'rgba(16,185,129,0.15)':a.tag==='flop'?'rgba(239,68,68,0.15)':'rgba(255,255,255,0.07)',
                        border: a.tag==='top'?'1px solid rgba(16,185,129,0.4)':a.tag==='flop'?'1px solid rgba(239,68,68,0.4)':'1px solid rgba(255,255,255,0.15)',
                        color: a.tag==='top'?'#10b981':a.tag==='flop'?'#ef4444':'rgba(200,215,235,0.5)',
                      }}>{a.tag==='top'?'▲Топ':a.tag==='flop'?'▼Слив':'○'}</span>
                    </div>
                  </div>
                </div>
                {/* Артикул WB */}
                <div style={{ width:FIXED_COLS[2].w, minWidth:FIXED_COLS[2].w, flexShrink:0, height:ROW_H,
                  position:'sticky', left:FIXED_LEFTS[2], zIndex:2, background:rowBg,
                  borderRight:'1px solid rgba(255,255,255,0.05)', boxSizing:'border-box',
                  display:'flex', alignItems:'center', justifyContent:'center' }}>
                  <span style={{fontSize:10,color:'rgba(200,215,235,0.6)',whiteSpace:'nowrap'}}><span className="blur-nmid">{a.nm_id}</span></span>
                </div>
                {/* Категория */}
                <div style={{ width:FIXED_COLS[3].w, minWidth:FIXED_COLS[3].w, flexShrink:0, height:ROW_H,
                  position:'sticky', left:FIXED_LEFTS[3], zIndex:2, background:rowBg,
                  borderRight:'2px solid rgba(255,255,255,0.18)', boxSizing:'border-box',
                  display:'flex', alignItems:'center', justifyContent:'center' }}>
                  <span style={{fontSize:10,color:'rgba(200,215,235,0.6)',padding:'0 6px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{a.subject || '—'}</span>
                </div>
                {/* Прокручиваемые ячейки */}
                {SCROLL_COLS.map((col, ci) => {
                  const { cellVal, autoVal, isReadOnly } = getCellData(a, col);
                  const isEmpty = cellVal === '';
                  const manualVal = rowData[String(a.nm_id)]?.[col.label + '|' + col.groupColor];
                  const globalDefault = getGlobalDefault(col.label, col.groupColor);
                  const effectiveAuto = autoVal !== null ? autoVal : (globalDefault !== null ? globalDefault : '');
                  const isManual = col.label !== 'Комиссия на 1 ед.' && manualVal != null && manualVal !== '' && String(manualVal) !== String(effectiveAuto);
                  const tooltip = getTooltip(a, col, cellVal, autoVal, manualVal, globalDefault);
                  const isGoodMargin = col.label === 'Маржа' && col.groupColor === '#091610' && cellVal && parseFloat(cellVal) > Number(params.stdMargin || 0);
                  const isBadMargin = col.label === 'Маржа' && col.groupColor === '#091610' && cellVal && parseFloat(cellVal) < 0;
                  return (
                    <div key={ci} title={tooltip} style={{
                      width: col.w, minWidth: col.w, flexShrink:0, height: ROW_H,
                      display:'flex', alignItems:'center', justifyContent:'center',
                      background: isGoodMargin ? 'rgba(0,255,80,0.35)' : isBadMargin ? 'rgba(239,68,68,0.25)' : isManual ? 'rgba(59,130,246,0.08)' : col.groupColor,
                      borderRight:'1px solid rgba(255,255,255,0.03)',
                      borderBottom: isManual ? '1px solid rgba(59,130,246,0.3)' : 'none',
                      boxSizing:'border-box', padding:'0 4px',
                    }}>
                      <input
                        value={cellVal}
                        readOnly={!(col.label === 'Себес.' && col.groupColor === '#1a1208')}
                        onChange={e => {
                          if (col.label === 'Себес.' && col.groupColor === '#1a1208') {
                            setCellVal(a.nm_id, col.label, col.groupColor, e.target.value);
                          }
                        }}
                        placeholder="—"
                        style={{
                          width:'100%', background:'transparent', border:'none',
                          color: isEmpty ? 'rgba(200,215,235,0.2)' : 'rgba(200,215,235,0.85)',
                          fontSize:10, textAlign:'center', outline:'none',
                          cursor: (col.label === 'Себес.' && col.groupColor === '#1a1208') ? 'text' : 'default', padding:0,
                        }}
                        onFocus={e => { if (col.label === 'Себес.' && col.groupColor === '#1a1208') e.target.style.background='rgba(255,255,255,0.05)'; }}
                        onBlur={e => e.target.style.background='transparent'}
                      />
                    </div>
                  );
                })}
              </div> {/* конец строки артикула */}
              {/* Черновик */}
              {openDrafts[a.nm_id] && (
                <div style={{ background:'#0a0f1a', borderBottom:'1px solid rgba(99,102,241,0.25)', borderTop:'1px solid rgba(99,102,241,0.25)', display:'flex', minWidth:TOTAL_W }}>
                  {/* Фиксированная левая часть */}
                  <div style={{ width:FIXED_W, minWidth:FIXED_W, flexShrink:0, position:'sticky', left:0, zIndex:3, background:'#0d1420', borderRight:'2px solid rgba(255,255,255,0.18)', display:'flex', alignItems:'center', paddingLeft:12, height:ROW_H, boxSizing:'border-box' }}>
                    <span style={{ fontSize:10, color:'rgba(165,180,252,0.7)', fontWeight:600 }}>&#x2022; Черновик</span>
                  </div>
                  {/* Прокручиваемые ячейки черновика */}
                  <div style={{ display:'flex' }}>
                    {SCROLL_GROUPS.map((group, gi) =>
                      group.cols.map((col, ci) => {
                        const id = String(a.nm_id);
                        const cellKey = col.label + '|' + group.color;
                        const draftRowData = draftData[id] || {};
                        const getDraftEV = () => {
                          const pd = prices[id] || {};
                          const dr = draftRowData;
                          const rd = rowData[id] || {};
                          const getVal = (key) => (dr[key] !== undefined && dr[key] !== null) ? dr[key] : rd[key];
                          const manualP = getVal('Цена до СПП|#0d1526');
                          const price = manualP != null ? Number(manualP) : (pd.price != null ? Number(pd.price) : 0);
                          const actualSpp = pd.spp_pct != null ? Number(pd.spp_pct) : Number(params.spp);
                          const priceSpp = Math.round(price*(1-actualSpp/100)*100)/100;
                          const cost = Number(getVal('Себес.|#1a1208') ?? costs[id] ?? 0);
                          const ff = Number(getVal('ФФ|#1a1208') ?? params.ff);
                          const itogSeb = cost + ff;
                          const vol = getVal('Объём (л)|#130f1a') ?? a.volume;
                          const logBase = Number(getVal('Логистика база|#130f1a') ?? calcLogBase(vol) ?? 0);
                          const vozvrat = Number(getVal('Стоимость возврата|#0b1220') ?? logBase);
                          const buyout = Number(getVal('Процент выкупа|#130f1a') ?? a.buyout_avg ?? a.buyout_w1 ?? 30);
                          const commPct = Number(getVal('Комиссия на 1 ед.|#1a0d0d') ?? params.commission ?? 20);
                          const commFbsPct = Number(getVal('Комиссия на 1 ед.|#1a0f0f') ?? 0);
                          const taxPct = Number(getVal('% Налога|#160b0b') ?? params.tax ?? 6);
                          const il = Number(params.coef1||1), koef = Number(params.coefSklad||1);
                          const irp = price > 0 ? Math.round(params.irp*price/100*100)/100 : 0;
                          const deliv = logBase*koef*il+irp;
                          const itogLog = buyout > 0 ? Math.round(((100-buyout)*(vozvrat+deliv)/buyout+deliv)*100)/100 : 0;
                          const volN = Number(vol);
                          const baseH = Number(params.storageBase||0);
                          const extraH = Number(params.storageExtra||0);
                          const sumDayAuto = volN > 0 ? (volN > 1 ? Math.round((baseH+(volN-1)*extraH)*1000)/1000 : Math.round(baseH*1000)/1000) : 0;
                          const sumDay = Number(getVal('Сумма на 1 ед. (в день)|#0b1220') ?? sumDayAuto);
                          const itogHran = Math.round(sumDay*Number(params.turnover||0)*100)/100;
                          const itogComm = price > 0 ? Math.round(price*commPct/100*100)/100 : 0;
                          const itogCommFbs = price > 0 ? Math.round(price*commFbsPct/100*100)/100 : 0;
                          const itogTax = priceSpp > 0 ? Math.round(priceSpp*taxPct/100*100)/100 : 0;
                          const profitNoRK = price > 0 ? Math.round((price-itogSeb-itogLog-itogHran-itogComm-itogTax)*100)/100 : null;
                          const profitNoRKFbs = price > 0 ? Math.round((price-itogSeb-itogLog-itogHran-itogCommFbs-itogTax)*100)/100 : null;
                          const drrPct = Number(params.drr||5);
                          const drrOnOrder = priceSpp > 0 ? Math.round(priceSpp*drrPct/100*100)/100 : 0;
                          const drrVykup = buyout > 0 ? Math.round(drrOnOrder/(buyout/100)*100)/100 : 0;
                          const profitRK = price > 0 ? Math.round((price-itogSeb-itogLog-itogHran-itogComm-itogTax-drrVykup)*100)/100 : null;
                          const profitRKFbs = price > 0 ? Math.round((price-itogSeb-itogLog-itogHran-itogCommFbs-itogTax-drrVykup)*100)/100 : null;
                          const drrFaktZakaz = Number(a.drr_fact ?? 0);
                          const drrFaktVykup = drrFaktZakaz > 0 && buyout > 0 ? Math.round((drrFaktZakaz/(buyout/100))*100)/100 : 0;
                          const doleLog = price > 0 && itogLog > 0 ? Math.round(itogLog/price*10000)/100 : null;
                          return { price, priceSpp, itogSeb, itogLog, itogHran, itogComm, itogCommFbs, itogTax, profitNoRK, profitNoRKFbs, profitRK, profitRKFbs, buyout, commPct, commFbsPct, taxPct, irp, sumDay, logBase, vol, drrOnOrder, drrVykup, drrFaktZakaz, drrFaktVykup, doleLog };
                        };
                        const dev = getDraftEV();
                        const readonlyMap = {
                          'Итог': group.color === '#1a1208' ? dev.itogSeb
                                : group.color === '#130f1a' ? dev.itogLog
                                : group.color === '#0b1220' ? dev.itogHran
                                : group.color === '#1a0d0d' ? dev.itogComm
                                : group.color === '#1a0f0f' ? dev.itogCommFbs
                                : group.color === '#160b0b' ? dev.itogTax : undefined,
                          'Чистая прибыль': group.color === '#0a1a14' ? dev.profitNoRK : dev.profitRK,
                          'Рента': (() => { const cp = group.color === '#0a1a14' ? dev.profitNoRK : dev.profitRK; return dev.itogSeb > 0 && cp != null ? Math.round(cp/dev.itogSeb*100) + '%' : null; })(),
                          'Маржа': (() => { const cp = group.color === '#0a1a14' ? dev.profitNoRK : dev.profitRK; return dev.price > 0 && cp != null ? Math.round(cp/dev.price*10000)/100 + '%' : null; })(),
                          'Маржа FBS': (() => { const cp = group.color === '#0a1a14' ? dev.profitNoRKFbs : dev.profitRKFbs; return dev.price > 0 && cp != null ? Math.round(cp/dev.price*10000)/100 + '%' : null; })(),
                          'Цена с СПП': dev.priceSpp > 0 ? dev.priceSpp : null,
                          'ИРП': dev.price > 0 ? dev.irp : null,
                          'Доля логистики': dev.doleLog != null ? dev.doleLog + '%' : null,
                          'ДРР факт выкуп': dev.drrFaktVykup > 0 ? dev.drrFaktVykup : null,
                          'Заказ': group.color === '#0f111a' ? (dev.priceSpp > 0 ? dev.drrOnOrder : null) : undefined,
                          'Выкуп': dev.drrVykup > 0 ? dev.drrVykup : null,
                        };
                        const isReadonly = col.label in readonlyMap && readonlyMap[col.label] !== undefined;
                        const calcVal = isReadonly ? readonlyMap[col.label] : null;
                        const baseValMap = {
                          'Себес.': costs[id] != null ? String(costs[id]) : (rowData[id]?.['Себес.|#1a1208'] ?? ''),
                          'ФФ': String(rowData[id]?.['ФФ|#1a1208'] ?? params.ff ?? ''),
                          'Цена до СПП': String(rowData[id]?.['Цена до СПП|#0d1526'] ?? prices[id]?.price ?? ''),
                          'Стоимость возврата': String(rowData[id]?.['Стоимость возврата|#0b1220'] ?? calcLogBase(a.volume) ?? ''),
                          'Процент выкупа': String(rowData[id]?.['Процент выкупа|#130f1a'] ?? a.buyout_avg ?? a.buyout_w1 ?? ''),
                          'Логистика база': String(rowData[id]?.['Логистика база|#130f1a'] ?? calcLogBase(a.volume) ?? ''),
                          'Объём (л)': String(rowData[id]?.['Объём (л)|#130f1a'] ?? a.volume ?? ''),
                          'Комиссия на 1 ед.': group.color === '#1a0f0f' ? String(rowData[id]?.['Комиссия на 1 ед.|#1a0f0f'] ?? '') : String(rowData[id]?.['Комиссия на 1 ед.|#1a0d0d'] ?? params.commission ?? ''),
                          'Сумма на 1 ед. (в день)': String(rowData[id]?.['Сумма на 1 ед. (в день)|#0b1220'] ?? (() => { const vn = Number(rowData[id]?.['Объём (л)|#130f1a'] ?? a.volume ?? 0); const bh = Number(params.storageBase||0); const eh = Number(params.storageExtra||0); return vn > 0 ? (vn > 1 ? Math.round((bh+(vn-1)*eh)*1000)/1000 : Math.round(bh*1000)/1000) : ''; })()),
                          '% Налога': String(rowData[id]?.['% Налога|#160b0b'] ?? params.tax ?? ''),
                          'ДРР факт заказ': a.drr_fact != null ? String(Math.round(Number(a.drr_fact)*100)/100) : '',
                        };
                        const baseVal = baseValMap[col.label] ?? String(rowData[id]?.[cellKey] ?? '');
                        const draftVal = draftRowData[cellKey];
                        const val = (draftVal !== undefined && draftVal !== null) ? String(draftVal) : baseVal;
                        const isModified = draftVal !== undefined && draftVal !== null && String(draftVal) !== baseVal;
                        return (
                          <div key={gi+'-'+ci} style={{ width:col.w, minWidth:col.w, flexShrink:0, height:ROW_H, display:'flex', alignItems:'center', justifyContent:'center', background: isModified ? 'rgba(99,102,241,0.15)' : group.color, borderRight:'1px solid rgba(255,255,255,0.04)', borderBottom: isModified ? '1px solid rgba(99,102,241,0.5)' : 'none', boxSizing:'border-box', padding:'0 4px' }}>
                            {isReadonly ? (
                              <span style={{ fontSize:10, color: calcVal != null ? 'rgba(200,215,235,0.85)' : 'rgba(200,215,235,0.25)' }}>
                                {calcVal != null ? String(calcVal) : '—'}
                              </span>
                            ) : (
                              <input
                                type="text"
                                key={cellKey+'-d'}
                                defaultValue={val}
                                onChange={e => {
                                  const v = e.target.value;
                                  setDraftData(prev => ({ ...prev, [id]: { ...(prev[id]||{}), [cellKey]: v === '' ? null : v } }));
                                }}
                                onBlur={async e => {
                                  const v = e.target.value;
                                  e.target.style.background = 'transparent';
                                  await api.post('/monitoring/unit-row-data-draft', { nmId: a.nm_id, cellKey, cellValue: v === '' ? null : v }).catch(()=>{});
                                }}
                                onFocus={e => e.target.style.background='rgba(255,255,255,0.05)'}
                                style={{ width:'100%', background:'transparent', border:'none', color: val === '' ? 'rgba(200,215,235,0.2)' : 'rgba(200,215,235,0.85)', fontSize:10, textAlign:'center', outline:'none', padding:0, cursor:'text' }}
                              />
                            )}
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              )}
              </div>
            );
          })}
        </div>
      </div>
      </div>
    </div>
  );
}
